import {createSelector} from '@ngrx/store';
import {selectRequestCount} from '../app.state';

export const selectLoading = createSelector(
  selectRequestCount,
  count => count > 0
);
